import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Field } from 'formik';
import { FieldSelectArrowIcon } from 'cstar-react-primitives';

import { quantityFieldMessages } from "./formFieldMessages";
import { QUANTITY_FIELD, LINE_ITEM_MAX_QUANTITY } from '.';

export const quantityPickerOptions = [...Array(LINE_ITEM_MAX_QUANTITY).keys()].map(num => (
    <option value={num + 1} key={String(num + 1)}>
        {String(num + 1)}
    </option>
));

export const QuantityPicker = () => (
    <div className="quantity-picker">
        <label className="quantity-picker-short-label" aria-label="Quantity" aria-hidden="true">
            <FormattedMessage {...quantityFieldMessages.quantityShort} />
        </label>
        <div className="field-group">
            <div className="field-group__div">
                <Field
                    component="select"
                    name={QUANTITY_FIELD}
                    className="field-group__select"
                    aria-label="Quantity"
                >
                    {quantityPickerOptions}
                </Field>
                <FieldSelectArrowIcon isInvalid={false} hasTransparentBackground={false} />
            </div>
        </div>
    </div>
);
